import { Injectable } from "@angular/core";
import * as CryptoJS from "crypto-js"; //imports

@Injectable({ providedIn: "root" })
export class HashingHelperService {
	decrypt(ciphertextB64) {
		if (!ciphertextB64) return "";

		var key = CryptoJS.enc.Utf8.parse("mysmallkey123456");
		var iv = CryptoJS.lib.WordArray.create([0x00, 0x00, 0x00, 0x00]);

		var decrypted = CryptoJS.AES.decrypt(ciphertextB64, key, { iv: iv });
		return decrypted.toString(CryptoJS.enc.Utf8);
	}

	//Data Encryption Function
	encryptData(msg) {
		var keySize = 256;
		var salt = CryptoJS.lib.WordArray.random(16);
		var key = CryptoJS.PBKDF2("mysmallkey123456", salt, {
			keySize: keySize / 32,
			iterations: 100,
		});

		var iv = CryptoJS.lib.WordArray.random(128 / 8);

		var encrypted = CryptoJS.AES.encrypt(msg, key, {
			iv: iv,
			padding: CryptoJS.pad.Pkcs7,
			mode: CryptoJS.mode.CBC,
		});

		var result = CryptoJS.enc.Base64.stringify(
			salt.concat(iv).concat(encrypted.ciphertext)
		);

		return result;
	}
}
